import React from "react";
import { Box } from "@mui/material";
import {
    ReviewCellValueButton,
    AttachedDocsButton,
    NotesActionButton,
    DeleteCellValueButton,
} from "./buttons";

interface ActionIconsProps {
    isArchivedTable: boolean;
    dataId: number | null;
    initialNotes?: string;
    cellData: any;
    userRoles: string[];
    isDisabled: boolean;
    isEditModalOpen?: boolean;
}

export const ActionIcons: React.FC<ActionIconsProps> = ({
    isArchivedTable,
    dataId,
    initialNotes,
    cellData,
    userRoles,
    isDisabled,
    isEditModalOpen = false,
}) => {
    if (isArchivedTable) return null;

    const canReviewCellValue = userRoles.some(role =>
        role === 'MODULE_ADMIN' ||
        role === 'SUPER_ADMIN' ||
        role === 'DATA_VALIDATOR' ||
        role === 'DATA_REVIEWER'
    );

    return (
        isEditModalOpen ? <DeleteCellValueButton dataId={dataId} /> :
            <Box
                data-testid="action-icons-container"
                sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gridTemplateRows: "1fr 1fr",
                    gap: "2px",
                    ml: 1
                }}>
                <ReviewCellValueButton
                    dataId={dataId}
                    isReviewed={cellData?.isReviewed}
                    disabled={isDisabled || !canReviewCellValue}
                />
                <AttachedDocsButton
                    dataId={dataId || 0}
                    hasDocuments={cellData?.hasDocuments}
                    disabled={isDisabled}
                />
                <Box />
                <NotesActionButton
                    dataId={dataId || 0}
                    initialNotes={initialNotes}
                    hasNotes={cellData?.hasNotes}
                    disabled={isDisabled}
                />
            </Box>

    );
};
